export default "__VITE_ASSET__BFVP7beS__"